import { EmploymentType, Query } from '@varo/graphql-schema-types';
import FetchEmployeeStatus from 'services/graphql/queries/FetchEmployeeStatus';
import { CombinedError, useQuery } from 'urql';

interface EmploymentTypes {
  result?: EmploymentType[];
  error?: CombinedError;
  fetching: boolean;
  refetch: () => void;
}

const useFetchEmployeeStatus = (): EmploymentTypes => {
  const [response, refetch] = useQuery<Query>({
    query: FetchEmployeeStatus,
    requestPolicy: 'cache-and-network',
  });

  const { data, fetching, error } = response;

  return {
    result: data?.employmentTypes,
    fetching,
    error,
    refetch,
  };
};

export default useFetchEmployeeStatus;
